<template>
    <div>
        <el-card class="card-login" shadow="always" :body-style="{ padding: '20px' }">
            <h2 class="pt-sans-bold">
                ALTA DE USUARIO - REGISTRO
                <br />
                <small> Espacio de formación personal </small>
            </h2>
            <div>
                <el-steps :active="active" finish-status="success" class="step-registro" align-center>
                    <el-step title="Verificar CUIL"></el-step>
                    <el-step title="Datos Personales"></el-step>
                    <el-step title="Confirmación"></el-step>
                </el-steps>
                <p style="text-align: left; background: #f1f1f1; padding: 10px" v-if="active == 0">
                    <strong>Nuevo usuario:</strong> para generar un nuevo usuario
                    vamos a verificar que su CUIL no se encuentre previamente
                    registrado en nuestras bases de datos.
                </p>
                <!-- <p style="text-align: left; background: #E8F5E9; padding: 10px" v-if="active == 2">
                    <strong>Usuario generado correctamente: </strong> sus datos de acceso son:


                </p> -->

                <el-form :model="form" ref="form" :label-position="'top'" class="login" :inline="false" size="normal"
                    @submit="validarCuit">

                    <el-row :gutter="20">
                        <el-col :sm="24" :offset="0" v-if="active == 0">

                            <br />
                            <el-form-item label="Ingresar CUIL (sin guiones)" prop="cuil" :rules="[
                  {
                    required: true,
                    message: 'campo obligatorio',
                    trigger: 'blur',
                  },
                ]">
                                <el-input v-mask="'############'" v-model="form.cuil"
                                    @keypress.native.enter="validarCuit"></el-input>
                            </el-form-item>
                            <br />
                            <el-button type="defaul1" :disabled="cargando ? true : false"
                                @click="cancelar('login')">Cancelar</el-button>

                            <el-button type="azul" @loading="cargando"
                                :disabled="form.cuil && form.cuil.length == 11 ? false : true" @click="validarCuit"
                                style="float: right">Verificar CUIL</el-button>
                        </el-col>
                        <el-col :sm="20" :offset="0" v-if="active == 1">
                            <el-form-item label="Apellido/s" prop="apellido" :rules="[
                  {
                    required: true,
                    message: 'campo obligatorio',
                    trigger: 'blur',
                  },
                ]">
                                <el-input v-model="form.apellido"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="20" :offset="0" v-if="active == 1">
                            <el-form-item label="Nombre/s" prop="nombre" :rules="[
                  {
                    required: true,
                    message: 'campo obligatorio',
                    trigger: 'blur',
                  },
                ]">
                                <el-input v-model="form.nombre"></el-input>
                            </el-form-item>
                        </el-col>


                        <el-col :sm="24" :offset="0" v-if="active == 1">
                            <el-form-item label="Genero" prop="genero" :rules="[
                                {
                                    required: true,
                                    message: 'campo obligatorio',
                                    trigger: 'blur',
                                },
                            ]">
                                <small data-v-6380aa7a="" style="
    display: block;
    line-height: 1;
    word-break: break-word;
    color: #E57373;
">Requerido para certificar, debe coincidir con DNI</small>
                                <el-radio-group v-model="form.genero" size="normal">
                                    <el-radio-button label="M">
                                        M
                                    </el-radio-button>
                                    <el-radio-button label="F">
                                        F
                                    </el-radio-button>
                                    <el-radio-button label="X">
                                        X
                                    </el-radio-button>
                                </el-radio-group>

                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" :offset="0" v-if="active == 1">
                            <el-form-item label="E-mail" prop="email" :rules="[
                  {
                    required: true,
                    message: 'campo obligatorio',
                    trigger: 'blur',
                  },
                  {
                    type: 'email',
                    message: 'correo invalido',
                    trigger: ['blur', 'change'],
                  },
                ]">
                                <el-input v-model="form.email"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="16" :offset="0" v-if="active == 1">
                            <el-form-item label="Teléfono" prop="telefono">
                                <el-input v-mask="'###############'" v-model="form.telefono"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" :offset="0" v-if="active == 1">
                            <el-form-item label="Contraseña" prop="pass" :rules="[
            {
                required: true,
                message: 'campo obligatorio',
                trigger: 'blur',
            },
        ]">
                                <el-input v-model="form.pass"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <br />
                                <el-button type="defaul1" @click="active = 0">Regresar</el-button>
                                <el-button type="azul" style="float: right" @click="guardarDatos('form')">Guardar
                                    datos</el-button>
                            </el-form-item>
                        </el-col>
                        <el-col :sm="24" :offset="0" v-if="active == 2">

                            <table class="table"
                                style="background:#FFF; width:100%; margin:0 auto; border:1px solid #f1f1f1 ">
                                <tr>
                                    <th colspan="2">Datos ingresados</th>
                                </tr>
                                <tr>
                                    <td>Usuario:</td>
                                    <th>{{ form.cuil }}</th>
                                </tr>
                                <tr>
                                    <td>Contraseña:</td>
                                    <th>{{ form.pass }}</th>
                                </tr>
                                <tr>
                                    <td>E-mail:</td>
                                    <th>{{ form.email }}</th>
                                </tr>

                            </table>

                            <div class="confirmacion">
                                <el-checkbox :fill="'#FF0000'" v-model="form.confirma">
                                    Confirmo que
                                    los datos ingresados <br> fueron verificados y son
                                    reales.</el-checkbox>
                                <!-- <small>En caso de alegar un error en el futuro las acciones realizadas con las mismas no
                                    serán validas </small> -->
                            </div>


                            <!-- <el-checkbox style="white-space:normal" border v-model="form.confirma">Confirmo que
                                los datos ingresados fueron verificados y son reales. </el-checkbox>
                            <small>En caso de alegar un error en el futuro las acciones realizadas con las mismas no
                                serán validas </small>
                            <br />
                            <br /> -->
                            <el-button type="defaul1" :disabled="cargando ? true: false"
                                @click="cancelar('login')">Salir</el-button>
                            <el-button type="azul" style="float: right" :loading="cargando"
                                :disabled="form.confirma ? false : true" @click="crearUsuario()">Crear
                                nuevo usuario</el-button>
                        </el-col>
                        <el-col :sm="24" :offset="0" v-if="active == 3">
                            <div style="text-align: left; background: #E8F5E9; padding: 10px">
                                <h2 style="font-size:17px; margin-bottom:20px">
                                    Usuario creado correctamente


                                </h2>
                                <p>Enviaremos un mensaje a su casilla de E-mail para verificarla</p>
                                <p>Sus datos de acceso son:</p>
                                <table class="table"
                                    style="background:#FFF; width:90%; margin:20px auto; border:1px solid #f1f1f1 ">
                                    <tr>
                                        <th colspan="2">Datos ingresados</th>
                                    </tr>
                                    <tr>
                                        <td>Usuario:</td>
                                        <th>{{ form.cuil }}</th>
                                    </tr>
                                    <tr>
                                        <td>Contraseña:</td>
                                        <th>{{ form.pass }}</th>
                                    </tr>


                                </table>

                                <el-button type="defaul1" :disabled="cargando ? true: false"
                                    @click="cancelar('login')">Salir</el-button>
                                <el-button type="azul" style="float: right" :loading="cargando"
                                    @click="Ingresar()">Ingresar</el-button>
                            </div>

                        </el-col>
                        <el-col :sm="24" :offset="0" v-if="active == 4">
                            <div style="text-align: left; background: #FFEBEE; padding: 10px; margin-bottom:20px">
                                <h2 style="font-size:17px; margin-bottom:20px">
                                    CUIL EXISTENTE
                                </h2>
                                <p> <strong>{{ form.cuil }}</strong> ya se encuentra registrado. <br>No se puede
                                    continuar con
                                    el registro</p>


                            </div>

                            <el-button type="defaul1" class="btn-100" :disabled="cargando ? true : false"
                                @click="cancelar('login')">Salir</el-button>

                            <el-button type="azul" class="btn-100" @click="cancelar('recuperar')">Recuperar
                                contraseña</el-button>

                        </el-col>
                    </el-row>


                </el-form>
            </div>
        </el-card>
    </div>
</template>

<script>
import { HTTP } from "@/axios"
import { EventBus } from '@/event-bus'
export default {
  data() {
    return {
      form: {},
      active: 0,
      cargando:false,
      existe: {}
    }
  },
  methods: {
      Ingresar()
      {
          this.cargando = true;
          EventBus.$emit('IngresarExt', this.form)
      },
      crearUsuario()
      {
          this.cargando = true;
          HTTP.post('/docente/crearUsuario', this.form)
              .then(res => {
                  this.cargando = false;
                  if (res.data) {

                  this.active = 3
                    

                  }
                  else {
                      this.$alert('No se pudo crear el usuario, refresque la página y reintente', { type: 'error' })
                  }


              })
              .catch((e) => {
                  this.cargando = false;
                  const msj = e.response && e.response.data ? e.response.data.error : 'El servidor no pudo procesar la solicitud';
                
                  this.$alert(
                      `<div class="error-message">
                         ${msj}
                      </div>`, 'No se pudo crear el usuario', 
                      {
                          dangerouslyUseHTMLString: true,
                        
                          customClass: 'custom-error-alert'
                      }
                  )
                  //   this.active = 1;
              })
      },
      validarCuit(event) {
          event.preventDefault();

     this.cargando = true;
          HTTP.post('/docente/validarCuil', {cuil: this.form.cuil})
              .then(res => {
                  this.cargando = false;
                if(res.data)
                {
                   
                    this.existe = res.data
                    this.active = 4;
                }
                else{
                    this.active = 1;
                }
                  
                  
              })
              .catch(() => {
                  this.cargando = false;
                //   this.active = 1;
                  

              })
    },
    guardarDatos(formName) {
       
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.active = 2
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    cancelar(vista) {
        EventBus.$emit('CancelarRe', vista)
    },
  },
}
</script>
<style>
.confirmacion{
    padding:10px; margin:10px auto;
    border: 1px dashed #EF9A9A;
    background: #FFEBEE;
    color:#000;
}
.confirmacion .el-checkbox__input.is-checked .el-checkbox__inner,
.confirmacion .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #E91E63;
    border-color: #E91E63;
}
.confirmacion .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000;
}

.confirmacion .el-checkbox__input {
    line-height: 1;
    margin-top: -17px;
}
.confirmacion small{
    display: block;
    border-top:1px solid #EF9A9A;
    margin-top: 20px;
    padding:10px
}
.step-registro {
  margin: 20px auto;
}

.step-registro .el-step__title {
  font-size: 12px;
  line-height: 2;
}

.error-message {
    background-color: #FFEBEE;
    border: 1px solid #EF9A9A;
    border-radius: 4px;
    padding: 10px;
    margin:  0;
    color: #D32F2F;
    font-size: 14px;
    line-height: 1.5;
    text-align: left;
}

.error-message i {
    color: #D32F2F;
    margin-right: 8px;
}

.error-message strong {
    display: block;
    margin-bottom: 5px;
    font-size: 16px;
}
</style>
<style lang="scss" scoped>
.card-login {
  margin-top: 80px;
  min-height: 610px;
//   overflow-y: scroll;
}

.card-login h2 {
  text-align: center;
  text-transform: uppercase;
  // margin: 0;
  font-size: 20px;
  line-height: 1.1;
}

.card-login p {
  text-align: center;
  font-size: 14px;
}

 .login {
     width: 80%;
     margin: 20px auto;
     margin-top: 10px;
 }

 .login-msj {
     font-size: 14px;
     padding: 10px;
     border: 1px solid #ef9a9a75;
     background: #ffebee70;
     border-radius: 4px;
 }
 @media screen and (max-width:768px) {
    .card-login {
        padding-top: 20px;
            margin-top: 0px;
            min-height: calc(100vh - 110px);
            //   overflow-y: scroll;
        }
 }
</style>